import { EventLocations } from "@/enums/EventLocations";


export const office365Service = {
  doesLocationNameMatchOffice365Room: (locationName: string, locations: any[], msRooms: any[]) =>{
    const isMatch = locations.some(location => {
        if (![EventLocations.Location, EventLocations.Room].includes(location.type)) return false;
        if (location.name !== locationName) return false;

        const lowerDifferentName = location?.differentName?.toLowerCase();
        const lowerOffice365Email = location?.office365Email?.toLowerCase();

        return msRooms.some(msRoom => {
            const lowerDisplayName = msRoom.displayName.toLowerCase();
            const lowerNickname = msRoom.nickname.toLowerCase();
            const lowerEmailAddress = msRoom.emailAddress.toLowerCase();

            return lowerDisplayName === lowerDifferentName ||
                  lowerNickname === lowerDifferentName ||
                  lowerEmailAddress === lowerOffice365Email;
        });
    });

    return isMatch
  },
  doesLocationMatchOffice365Room: (location: any, msRooms: any[]) =>{
    if (![EventLocations.Location, EventLocations.Room].includes(location.type)) return false;

    const lowerDifferentName = location?.differentName?.toLowerCase();
    const lowerOffice365Email = location?.office365Email?.toLowerCase();

    return msRooms.some(msRoom => {
        const lowerDisplayName = msRoom.displayName.toLowerCase();
        const lowerNickname = msRoom.nickname.toLowerCase();
        const lowerEmailAddress = msRoom.emailAddress.toLowerCase();
        return lowerDisplayName === lowerDifferentName ||
              lowerNickname === lowerDifferentName ||
              lowerEmailAddress === lowerOffice365Email;
    });
  }
}